import React from 'react';
import PropTypes from 'prop-types';

export const No = ({ width, height, ...props }) => (
  <svg
    data-icon='no'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M12 22a9.738 9.738 0 0 1-3.9-.788 10.099 10.099 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.738 9.738 0 0 1 2 12c0-1.383.263-2.683.788-3.9a10.099 10.099 0 0 1 2.137-3.175c.9-.9 1.958-1.612 3.175-2.137A9.738 9.738 0 0 1 12 2c1.383 0 2.683.263 3.9.788a10.098 10.098 0 0 1 3.175 2.137c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0 1 22 12a9.738 9.738 0 0 1-.788 3.9 10.098 10.098 0 0 1-2.137 3.175c-.9.9-1.958 1.613-3.175 2.137A9.738 9.738 0 0 1 12 22Zm0-2c.9 0 1.767-.146 2.6-.438a7.951 7.951 0 0 0 2.3-1.262L5.7 7.1a7.95 7.95 0 0 0-1.263 2.3A7.813 7.813 0 0 0 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20Zm6.3-3.1c.55-.7.97-1.467 1.262-2.3.292-.833.438-1.7.438-2.6 0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-.9 0-1.767.146-2.6.438A7.95 7.95 0 0 0 7.1 5.7l11.2 11.2Z'
    />
  </svg>
);

No.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

No.defaultProps = {
  width: 24,
  height: 24,
};
